import {SeriesResponseBody, SeriesType} from '@dms/api/core';

import {Nullish} from 'shared/web';

export const getSoleSeriesId = (
  series: Pick<SeriesResponseBody, 'id' | 'type'>[] | Nullish,
  type: SeriesType
) => {
  const matching = series?.filter((serie) => serie.type === type) ?? [];

  return matching.length === 1 ? matching[0]?.id : undefined;
};
